import { BufferWriter, Writer } from "protobufjs";

import { IApiClient } from "../client";
import { api, entity } from "../rpc/api";
import { getToken } from "./bind_token";

class ContractOperationReportAPI {
  constructor(readonly apiClient: IApiClient) {}

  public getAllByContract(
    contractId: string
  ): Promise<entity.IContractOperationReport[]> {
    return new Promise<entity.IContractOperationReport[]>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: entity.ContractID = new entity.ContractID();
          req.id = contractId;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.ContractOperationReportService/GetAllByContract",
            token,
            entity.ContractID.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res = entity.ContractOperationReportList.decode(binary);
          resolve(res.items);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  }

  public get = (id: string): Promise<entity.IContractOperationReport> => {
    return new Promise<entity.IContractOperationReport>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: entity.ContractOperationReportID =
            new entity.ContractOperationReportID();
          req.id = id;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.ContractOperationReportService/Get",
            token,
            entity.ContractOperationReportID.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res: entity.ContractOperationReport =
            entity.ContractOperationReport.decode(binary);
          resolve(res);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  };

  public create = (
    contractId: string,
    targetYM: string,
    detail: string,
    satisfactionLevel: entity.ContractOperationReport.SatisfactionLevel,
    continuationLevel: entity.ContractOperationReport.ContinuationLevel,
    supportRequest: string,
    otherRequest: string,
    endScheduledYM: string
  ): Promise<entity.IContractOperationReport> => {
    return new Promise<entity.IContractOperationReport>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: api.CreateContractOperationReportRequest =
            new api.CreateContractOperationReportRequest();
          req.contractID = contractId;
          req.targetYM = targetYM;
          req.detail = detail;
          req.satisfactionLevel = satisfactionLevel;
          req.continuationLevel = continuationLevel;
          req.supportRequest = supportRequest;
          req.otherRequest = otherRequest;
          req.endScheduledYM = endScheduledYM;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.ContractOperationReportService/Create",
            token,
            api.CreateContractOperationReportRequest.encode(
              req,
              writer
            ).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res: entity.ContractOperationReport =
            entity.ContractOperationReport.decode(binary);
          resolve(res);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  };
}

const createContractOperationReportAPI = (apiClient: IApiClient) => {
  return new ContractOperationReportAPI(apiClient);
};

export { createContractOperationReportAPI };



// WEBPACK FOOTER //
// ./src/infra/api/service/contract_operaton_report_api.ts